// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"H4-z","dimensionLabel":"I4-z","styleChooserControlWrapper":"J4-z","styleChooserControl":"K4-z","disabled":"L4-z","giftCard":"M4-z","styleChooserText":"N4-z"};